import React from "react";

const SearchFormSort = ({
  sortEventKeys,
  sortEventFunc,
  eventCondition = "",
}) => {

  return (
    <div>
      <div className="search-event__narrow-btn">
        <button
          className={`btn btn-sm rounded-pill ${
            !eventCondition ? "btn-secondary" : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.poplular}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          人気順
        </button>
        <button
          className={`text-fz-14px btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.recently
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.recently}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          開催順
        </button>
        <button
          className={`btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.new
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.new}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          新着
        </button>

      </div>
      {/* <button
        className={`mt-3 btn btn-sm rounded ${
          eventCondition == sortEventKeys.newCircle
            ? "btn-secondary"
            : "btn-outline-secondary"
        } px-3 mr-2`}
        style={{ fontSize: "0.8rem" }}
        value={sortEventKeys.newCircle}
        onClick={(e) => sortEventFunc(e.target.value)}
      >
        新規サークルのイベント
      </button> */}
    </div>
  );
};

export default SearchFormSort;
